'use client';

import { AuthProvider } from '@/context/auth-context';
import { StoreProvider } from '@/context/store-context';
import { SettingsProvider } from '@/context/settings-context';
import { LocaleProvider } from '@/context/locale-context';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <LocaleProvider>
      <AuthProvider>
        <StoreProvider>
          <SettingsProvider>{children}</SettingsProvider>
        </StoreProvider>
      </AuthProvider>
    </LocaleProvider>
  );
}
